import SendPasswordResetModal from './SendPasswordResetModal';

export default SendPasswordResetModal;
